export default {"src":"/_next/static/media/thumbs_down.3fd81880.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};